import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  withMobileDialog,
  Dialog,
  withStyles,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import { toggleDialog } from 'actions/view'
import Button from 'components/theme/Button'
import { create, update } from 'actions/data'

// Add these constants for the use case options
const USE_CASE_OPTIONS = [
  'CUSTOMER_CARE',
  'MARKETING',
  'K12_EDUCATION',
  'POLITICAL',
  'MIXED',
  'LOW_VOLUME',
]
  .sort()
  .map(value => ({
    value,
    label: value.replace(/_/g, ' '),
  }))

const AddUseCaseDialog = ({
  dialogOpen,
  toggleDialog,
  campaigns,
  useCaseDrafts,
}) => {
  const [selectedUseCase, setSelectedUseCase] = useState('')

  // Add this function to determine the directive
  const getDirective = () => {
    const existingUseCases = [
      ...Object.keys(campaigns),
      ...Object.keys(useCaseDrafts),
    ]
    const hasOnlyLowVolume = 
      existingUseCases.length === 1 && 
      existingUseCases[0] === 'LOW_VOLUME'
    
    return hasOnlyLowVolume 
      ? 'upgradeToHighVolume'
      : 'additionalHighVolumeUseCase'
  }

  return (
    <Dialog
      open={Boolean(dialogOpen)}
      onClose={() => {
        toggleDialog({
          open: false,
          dialog: 'AddUseCase',
        })
        setSelectedUseCase('')
      }}
      aria-labelledby="add-use-case-dialog"
    >
      <DialogTitle id="add-use-case-dialog">Add New Use Case</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel>Use Case Type</InputLabel>
          <Select
            value={selectedUseCase}
            onChange={e => setSelectedUseCase(e.target.value)}
          >
            {USE_CASE_OPTIONS.map(option => (
              <MenuItem
                disabled={
                  useCaseDrafts[option.value] || campaigns[option.value]
                }
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            toggleDialog({ open: false, dialog: 'AddUseCase' })
            setSelectedUseCase('')
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={!selectedUseCase}
          color="primary"
          onClick={() => {
            toggleDialog({
              open: false,
              dialog: 'AddUseCase',
            })
            
            toggleDialog({
              open: true,
              dialog: 'A2P10DLC',
              options: { 
                directive: getDirective(),
                useCase: selectedUseCase,
              },
            })
          }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default withRouter(
  connect(
    state => ({
      dialogOpen: state.view.dialogs?.AddUseCase?.open,
      campaigns: Object.values(state.data.a2p10dlc || {})?.[0]?.campaigns || {},
      useCaseDrafts:
        Object.values(state.data.a2p10dlc || {})?.[0]?.useCaseDrafts || {},
    }),
    dispatch =>
      bindActionCreators(
        {
          toggleDialog,
          create,
          update,
        },
        dispatch,
      ),
  )(withMobileDialog()(withStyles(theme => ({}))(AddUseCaseDialog))),
)
